import { LumiDB } from "@lumidb/lumidb";
import { proxy } from "valtio";
import { getEnvVar } from "./utils";

const LINK_TOKEN_KEY = "lumidb-link-token";

export class Auth {
    public state = proxy({
        publishableKey: null as string | null,
        user: null as string | null,
        email: null as string | null,
        orgRole: null as string | null,
        orgSlug: null as string | null,
        apikey: null as string | null,
        link: null as string | null,
    });

    getToken: () => Promise<string | null> = () => Promise.resolve(null);

    clearLinkToken(): void {
        sessionStorage.removeItem(LINK_TOKEN_KEY);
    }

    async getHeader(): Promise<string | null> {
        if (this.state.link) {
            return `link ${this.state.link}`;
        }

        if (this.state.user === "apikey" && this.state.apikey) {
            return `apikey ${this.state.apikey}`;
        }

        const token = await this.getToken();
        if (!token) return null;
        return `clerk ${token}`;
    }

    private isSameOrigin(url: string): boolean {
        try {
            return new URL(url, window.location.href).origin === window.location.origin;
        } catch {
            return false;
        }
    }

    async fetch(url: string, options: RequestInit = {}): Promise<Response> {
        if (this.isSameOrigin(url)) {
            const header = await this.getHeader();
            if (!header) throw new Error("No authentication header available");

            options.headers = { ...options.headers, Authorization: header };
            return fetch(url, options);
        }

        return fetch(url, options);
    }

    constructor(lumidb: LumiDB) {
        const publishableKey = getEnvVar("VITE_CLERK_PUBLISHABLE_KEY");
        if (publishableKey) {
            this.state.publishableKey = publishableKey;
        }

        const params = new URLSearchParams(window.location.search);
        const linkToken = params.get("token") ?? sessionStorage.getItem(LINK_TOKEN_KEY);

        if (linkToken) {
            sessionStorage.setItem(LINK_TOKEN_KEY, linkToken);
            this.state.link = linkToken;
            this.state.user = "link";
            lumidb.setAuthentication({ link: linkToken });
            return;
        }

        // User etc. will be set in Auth.tsx
        if (publishableKey) return;

        const apikey = prompt("Enter API key");

        if (apikey) {
            this.state.user = "apikey";
            this.state.apikey = apikey;
            this.state.orgRole = "org:admin";
            lumidb.setAuthentication({ apikey });
            return;
        }

        throw new Error("No authentication method found");
    }
}
